import { render, staticRenderFns } from "./edutalk-customer-form.vue?vue&type=template&id=166337d6"
import script from "./edutalk-customer-form.vue?vue&type=script&lang=js"
export * from "./edutalk-customer-form.vue?vue&type=script&lang=js"
import style0 from "./edutalk-customer-form.vue?vue&type=style&index=0&id=166337d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports